import React from "react";
import {
  getGenericInputStylesCP,
  getGenericInputStylesContainerTelcel,
} from "../../../styles/genericInput";

class GenericInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputStyles: {},
    };
  }

  componentDidMount() {
    const { isContainerTelcel, imgInputIcon, showIcon } = this.props;
    const stylesValues = isContainerTelcel
      ? getGenericInputStylesContainerTelcel(imgInputIcon, showIcon)
      : getGenericInputStylesCP(imgInputIcon, showIcon);
    this.setState({
      inputStyles: stylesValues,
    });
  }

  render() {
    const {
      inputStyles: { input },
    } = this.state;
    const { inputInfo, handleOnChangeInput, value, handleOnClickInput } =
      this.props;
    const { pattern, inputMode, type, id, name, placeHolder, min, max, onlyRead } =
      inputInfo;
    return (
      <input
        pattern={pattern}
        inputMode={inputMode}
        type={type}
        id={id}
        name={name}
        required
        style={input}
        value={value}
        onChange={(e) => handleOnChangeInput(e, id)}
        onClick={(e) => handleOnClickInput(e, id)}
        placeholder={placeHolder}
        min={min}
        max={max}
        readOnly={onlyRead}
      />
    );
  }
}
export default GenericInput;
